export const API_URL = process.env.VUE_APP_API_URL;
export const CLIENT_ID = process.env.VUE_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.VUE_APP_CLIENT_SECRET;
export const REDIRECT_URI = process.env.VUE_APP_REDIRECT_URI;
export const SCOPE = [];
export const SSO_URL = process.env.VUE_APP_SSO_URL;
export const OFFLINE_ACTIVATION_DOCUMENTATION = process.env.VUE_APP_OFFLINE_ACTIVATION_DOC;
export const PERFORM_URL = process.env.VUE_APP_PERFORM_URL;
